import { BaseModel } from '../base-model';

export interface IGenericObject {
  IconUrl?: string;
  Id?: number;
  NameEN?: string;
  NameFR?: string;
  NameNL?: string;
  NameDE?: string;
  Name?: string;
  ParentId?: number;
  Expression?: string;
  CategoryTypeId?: number;
  // additional
  Checked?: boolean;
}
export class GenericObject extends BaseModel<IGenericObject> implements IGenericObject {
  IconUrl: string;
  Id: number;
  NameEN: string;
  NameFR: string;
  NameNL: string;
  NameDE?: string;
  Name: string;
  ParentId: number;
  Expression: string;

  // additional
  Checked?: boolean;
  /**
   *
   */
  constructor(option?: IGenericObject) {
    super(option);
  }
}